import { inject, Injectable } from '@angular/core';
import { INotificationReceiver } from './notification.model';
import { UtilityService } from '../../services/utility.service';
import { IObjectLiteral } from 'ets-fe-ng-sdk';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NotificationHandlerService {
  readonly uS = inject(UtilityService);
  readonly router = inject(Router);

  serviceHandleNotificationOpen(notification: INotificationReceiver) {
    console.log(notification);
    const refCat = notification._notification?.refCat,
      refNo = notification._notification?.refNo;
    switch (refCat) {
      case 'WKF': // ENotificationRefCat.workflow
        this.go('workflow-desk/view/index', { wfNo: refNo });
        return true;
      case 'QUO': // ENotificationRefCat.quote
        this.go('policy-desk/view-proposal', { quoteNo: refNo, screen: 'POL' });
        return true;
      case 'CLM': // ENotificationRefCat.claim
        this.go('payment-desk/view-claim', { claimNo: refNo });
        return true;
      case 'BAT': // ENotificationRefCat.batch
        this.go('admin-desk/batch/activities', { requestId: refNo });
        return true;
      default:
        return false;
    }
  }

  openDocument(notification: INotificationReceiver) {
    // this.uS.dialogOpener(
    //   ViewDocumentModalComponent,
    //   { width: '80%', data: { notification } },
    //   () => {},
    // );
    return true;
  }
  handleNotificationOpen(notification: INotificationReceiver) {
    if (notification._notification?.refCat === 'DOC') return this.openDocument(notification);
    else return this.serviceHandleNotificationOpen(notification);
  }
  protected go(route: string, queryParams: IObjectLiteral) {
    return this.router.navigate([route], { queryParams: { ...queryParams, useRedirect: true } });
  }
}
